import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import Image from '../Image/Image';
import Typography from '../Typography';
import playButton from '../../assets/play-button.svg';
import styles from './BackgroundCarousel.module.sass';
import PerfectScrollbar from 'react-perfect-scrollbar';

const BackgroundCarousel = ({ useSetDefault = true, small, message, backgrounds, defaultBg, onSelection, onLoad, highlight, onMouseDown, scrollable }) => {
  const ref = useRef(null);
  const [selected, setSelected] = useState();
  // TODO: need to figure out a way to implement smooth scrolling for react-perfect-scrollbar
  // adding scroll-behavior: smooth to the container breaks the natural scrolling
  const scrollRight = () => {
    ref.current.scrollLeft += (scrollable ? 250 : 250)
  }
  const scrollLeft = () => {
    ref.current.scrollLeft -= (scrollable ? 250 : 250)
  }

  const selectionHandler = background => {
    setSelected(background.id);
    onSelection(background);
  };

  useEffect(() => {
    if (!useSetDefault) return
    if (defaultBg) selectionHandler(defaultBg);
    else if (backgrounds.length > 0) selectionHandler(backgrounds[0]);

  }, [backgrounds.length, useSetDefault]);

  useEffect(() => {
    if (scrollable) import('./smooth.css')
  }, [scrollable])

  if (backgrounds.length === 0) return null;

  const bgImgClasses = {
    [styles.bgImg]: true,
    [styles.small]: small,
  }

  return (
    <div className={styles.container}>
    <Typography align="center" tag="h3" weight="bold">{message}</Typography>
      <div className={styles.carouselContainer}>
        <div onClick={scrollLeft} className={styles.arrowContainer}>
          <div className={styles.arrowWrapper}>
            <Image src={playButton} classes={cn(styles.playButton, styles.scrollLeftBtn)} />
          </div>
        </div>
      <div ref={ref} className={styles.bgSelectionContainer}>
        {/*<PerfectScrollbar containerRef={container => ref.current = container}>*/}
          <div className={styles.bgContainer}>
            {backgrounds.map((background, i) =>
              <div
                key={background.id}
                onClick={() => selectionHandler(background)}
                onMouseDown={() => onMouseDown(background)}
                onTouchStart={() => onMouseDown(background)}
                className={cn({ ...bgImgClasses, [styles.active]: selected === background.id && highlight })}
              >
                <Image onLoad={i === backgrounds.length - 1 && onLoad} src={background.imageUrl} />
              </div>
            )}
          </div>
        {/*</PerfectScrollbar>*/}
      </div>
        <div className={styles.arrowContainer} onClick={scrollRight}>
          <div className={styles.arrowWrapper}>
            <Image classes={cn(styles.playButton, styles.rightButton)} src={playButton} />
          </div>
        </div>
      </div>
    </div>
  );
};

BackgroundCarousel.defaultProps = {
  message: 'Please select a background',
  backgrounds: [],
  highlight: true,
  onMouseDown: () => { },
  onSelection: () => { },
  scrollable: true,
  small: false,
};

BackgroundCarousel.propTypes = {
  title: PropTypes.string,
  backgrounds: PropTypes.array.isRequired,
  onSelection: PropTypes.func,
  onMouseDown: PropTypes.func,
  scrollable: PropTypes.bool,
  small: PropTypes.bool,
};

export default BackgroundCarousel;
